import { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, Factory, Warehouse, Calendar, MoreHorizontal } from 'lucide-react';
import './mobile.css';

const tabs = [
  { key: 'home', label: 'Home', icon: Home, path: '/mobile' },
  { key: 'production', label: 'Production', icon: Factory, path: '/mobile/production' },
  { key: 'warehouse', label: 'Warehouse', icon: Warehouse, path: '/mobile/warehouse' },
  { key: 'schedule', label: 'Schedule', icon: Calendar, path: '/mobile/schedule' },
  { key: 'more', label: 'More', icon: MoreHorizontal, path: '/mobile/more' },
];

export default function MobileLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('home');

  // Hide Emergent badge on mobile
  useEffect(() => {
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.display = 'none';
    return () => { if (badge) badge.style.display = ''; };
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/mobile' || path === '/mobile/') setActiveTab('home');
    else if (path.startsWith('/mobile/production')) setActiveTab('production');
    else if (path.startsWith('/mobile/warehouse')) setActiveTab('warehouse');
    else if (path.startsWith('/mobile/schedule')) setActiveTab('schedule');
    else if (path.startsWith('/mobile/more') || path.startsWith('/mobile/rd') || path.startsWith('/mobile/crm')) setActiveTab('more');
  }, [location.pathname]);

  const handleTabClick = (tab) => {
    setActiveTab(tab.key);
    navigate(tab.path);
  };

  return (
    <div className="mobile-app">
      {/* Top Status Bar */}
      <header className="mobile-header">
        <div className="mobile-header-content">
          <img
            src="https://customer-assets.emergentagent.com/job_mfg-workorder-app/artifacts/fp1li17d_Mockingbird-Food-Group_Black.png"
            alt="Logo"
            className="mobile-header-logo"
          />
          <span className="mobile-header-title">Rudder</span>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="mobile-main">
        <Outlet />
      </main>

      {/* Bottom Tab Bar */}
      <nav className="mobile-bottom-nav">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              className={`mobile-tab ${isActive ? 'mobile-tab-active' : ''}`}
              onClick={() => handleTabClick(tab)}
            >
              <Icon className="mobile-tab-icon" />
              <span className="mobile-tab-label">{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
